import { render, staticRenderFns } from "./ConstructingPage.vue?vue&type=template&id=c9acb70a&scoped=true"
import script from "./ConstructingPage.vue?vue&type=script&lang=js"
export * from "./ConstructingPage.vue?vue&type=script&lang=js"
import style0 from "./ConstructingPage.vue?vue&type=style&index=0&id=c9acb70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9acb70a",
  null
  
)

export default component.exports